import React from "react";
import { StylesContextData } from "./styles-context-data";

export const StylesContext = React.createContext<StylesContextData | null>(
  null
);
